import { IsNotEmpty } from 'class-validator-i18n';

import { AuthenticateByBaseRequestDTO } from './AuthenticateByBaseRequestDTO';

export class AuthenticateByEmailPasswordRequestDTO extends AuthenticateByBaseRequestDTO {
  @IsNotEmpty()
  password: string;
}
